// extracted by mini-css-extract-plugin
export default {"reasonCellContent":"zKBBhHBiZISxTZdTVqO1","table":"HJHkZCa7_9sH1mPdPgI0"};